export enum UserStatus {
    Enabled = 'Enabled',
    Disabled = 'Disabled',
    PendingReview = 'PendingReview',
}
